<template>
  <div class="timer-container">
  <p style="color: #333639;">
    {{ `Reativar (${minutes}min ${seconds <= 10 ? '0' + seconds + 's' : seconds + 's'}).` }}
  </p>
</div>
</template>

<style>
.timer-container {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
}

.timer-text {
  color: white;
  text-align: center;
}
</style>

<script>
export default {
  props: {
    time: {
      type: Number,
      required: true
    },
    onComplete: {
      type: Function,
      required: true
    }
  },
  data() {
    return {
      time: this.time,
      seconds: this.time - Math.floor((this.time - 1) / 60) * 60 - 1,
      minutes: Math.floor((this.time - 1) / 60)
    };
  },
  mounted() {
    this.intervalId = setInterval(this.decreaseTime, 1000);
  },
  methods: {
    decreaseTime() {
      if (this.time === 0) {
        this.onComplete();
      } else {
        this.time--;
        this.seconds = this.time - Math.floor((this.time - 1) / 60) * 60 - 1;
        this.minutes = Math.floor((this.time - 1) / 60);
      }
    }
  },
  beforeUnmount() {
    clearInterval(this.intervalId);
  }
};
</script>
